import type {WorkspaceMobileBottomCreateItem} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceMobileBottomCreateItem";
import {
    AMARON__CALL__LOG__FORM__ID,
    AMARON__CALL__SCHEDULE__FORM__ID,
} from "~/domainModels/workspaceSpecific/amaron";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

/** UI-only form id for journey create route (`/journeys/create`). */
// const AMARON__UI__JOURNEY_CREATE__FORM__ID = "b82cd4e5-f6a7-48b9-c0d1-a2f3a4b50617" as Uuid;
const AMARON__UI__INVITE_USER__FORM__ID = "a91bc3d4-e5f6-47a8-b9c0-b1e2f3a4b506" as Uuid;

// const AMARON__UI__JOURNEY_CREATE__ID = "c03ad5f6-a7b8-49c0-b1e2-f3a4b5061728" as Uuid;
const AMARON__UI__SCHEDULE_CALL_SHEET__ID = "e25cf8a1-3b4c-4d5e-9f60-a1b2c3d4e5f6" as Uuid;
const AMARON__UI__LOG_CALL_SHEET__ID = "f36df9b2-4c5d-4e6f-a071-b2c3d4e5f607" as Uuid;
// const AMARON__UI__BOOK_SERVICE_SHEET__ID = "a47ef0c3-5d6e-4f7a-b182-c3d4e5f60718" as Uuid;
const AMARON__UI__INVITE_USER__ID = "d14be6a7-b8c9-41d1-82f3-a4b506172839" as Uuid;

/**
 * Default mobile Create sheet for Amaron when `workspaceUi.configuration.mobileBottomCreateSheet` is omitted.
 */
export const AMARON_DEFAULT_MOBILE_BOTTOM_CREATE_SHEET: readonly WorkspaceMobileBottomCreateItem[] = [
    {
        id: AMARON__UI__SCHEDULE_CALL_SHEET__ID,
        formId: AMARON__CALL__SCHEDULE__FORM__ID,
        formUrl: "amaron/call/schedule",
        iconId: "scheduleCall",
        displayName: "Schedule a call",
    },
    {
        id: AMARON__UI__LOG_CALL_SHEET__ID,
        formId: AMARON__CALL__LOG__FORM__ID,
        formUrl: "amaron/call/log",
        iconId: "logCall",
        displayName: "Log a call",
    },
    {
        id: AMARON__UI__INVITE_USER__ID,
        formId: AMARON__UI__INVITE_USER__FORM__ID,
        formUrl: "user-invitation",
        iconId: "inviteUser",
        displayName: "Invite user",
    },
];
